import React from 'react';
import { ASSET_PREFIX } from 'utils/constants';

const LeaderboardRafflePrize = (currentLeaderboardDrawId) => {
  // Earlier prizes (these prizes are displayed while the SCHEDULED leaderboard draw's ID matches).
  if (parseInt(currentLeaderboardDrawId, 10) === 26)
    return {
      lastMonthsPrize: {
        heading: '£150 AirBnB Gift Card',
        backgroundImage: `${ASSET_PREFIX}/images/leaderboard/prizes/airbnb.jpeg`,
        includesList: [<>£150 AirBnB Gift Card</>],
      },
      upcomingPrize: {
        heading: '£150 AirBnB Gift Card',
        backgroundImage: `${ASSET_PREFIX}/images/leaderboard/prizes/airbnb.jpeg`,
        includesList: [<>£150 AirBnB Gift Card</>],
      },
    };

  // Later prizes (these prizes are displayed if the ID does not match (i.e. after the draw)).
  return {
    lastMonthsPrize: {
      heading: '£150 AirBnB Gift Card',
      backgroundImage: `${ASSET_PREFIX}/images/leaderboard/prizes/airbnb.jpeg`,
      includesList: [<>£150 AirBnB Gift Card</>],
    },
    upcomingPrize: {
      heading: '£150 AirBnB Gift Card',
      backgroundImage: `${ASSET_PREFIX}/images/leaderboard/prizes/airbnb.jpeg`,
      includesList: [<>£150 AirBnB Gift Card</>],
    },
  };
};

export default LeaderboardRafflePrize;
